import React from "react";
import Checkbox from "@mui/material/Checkbox";
import { Box } from "@mui/system";

export default function ExpertPaymentCheckboxParent({ allSelected, someSelected, onToggleAll }) {
    return (
        <Box>
            <Checkbox
                checked={allSelected}
                indeterminate={someSelected && !allSelected}
                onChange={onToggleAll}
                sx={{
                    color: "#c8c8c8",
                    width: "33px",
                    height: "33px",
                    "&.Mui-checked": {
                        color: "#003300",
                    },
                    "&.MuiCheckbox-indeterminate": {
                        color: "#003300",
                    },
                }}
            />
        </Box>
    );
}